import { NgModule } from "@angular/core";
import { ExtraOptions, Route, RouterModule } from "@angular/router";
import { AboutUsComponent } from "src/app/view/about-us/about-us.component";
import { CommitteeComponent } from "src/app/view/about-us/committee/committee.component";
import { GoverningComponent } from "src/app/view/about-us/governing/governing.component";
import { MessagesComponent } from "src/app/view/about-us/messages/messages.component";
import { OrganogramComponent } from "src/app/view/about-us/organogram/organogram.component";
import { PerspectiveComponent } from "src/app/view/about-us/perspective/perspective.component";
import { ProfileComponent } from "src/app/view/about-us/profile/profile.component";
import { ResearchCentreComponent } from "src/app/view/about-us/research-centre/research-centre.component";
import { RtiComponent } from "src/app/view/about-us/rti/rti.component";
import { SearchComponent } from "src/app/view/about-us/search/search.component";
import { StaffComponent } from "src/app/view/about-us/staff/staff.component";
import { VisionPlanComponent } from "src/app/view/about-us/vision-plan/vision-plan.component";
import { NaacAccreditationComponent } from "src/app/view/about-us/naac-accreditation/naac-accreditation.component";
import { RecognitionsComponent } from "src/app/view/about-us/recognitions/recognitions.component";
import { FinancialsComponent } from "src/app/view/about-us/financials/financials.component";
import { AdministrationComponent } from "src/app/view/about-us/administration/administration.component";
import { ResearchProjectComponent } from "src/app/view/about-us/research-project/research-project.component";
import { SeminarConferenceComponent } from "src/app/view/about-us/seminar-conference/seminar-conference.component";


const route: Route[] = [
    {
        path: '', component: AboutUsComponent, children: [
            { path: 'profile', component: ProfileComponent },
            { path: 'governing', component: GoverningComponent },
            { path: 'messages', component: MessagesComponent },
            { path: 'research-centre', component: ResearchCentreComponent },
            { path: 'staff', component: StaffComponent },
            { path: 'committee', component: CommitteeComponent },
            { path: 'organogram', component: OrganogramComponent },
            { path: 'rti', component: RtiComponent },
            { path: 'perspective', component: PerspectiveComponent },
            { path: 'search-facility', component: SearchComponent },
            { path: 'vision-plan', component: VisionPlanComponent },
            { path: 'naac-accreditation', component: NaacAccreditationComponent },
            { path: 'recognitions', component: RecognitionsComponent },
            { path: 'financials', component: FinancialsComponent },
            { path: 'administration', component: AdministrationComponent },
            { path: 'research-project', component: ResearchProjectComponent },
            { path: 'seminar-conference', component: SeminarConferenceComponent },

        ]
    }
]
@NgModule({
    imports: [
        RouterModule.forChild(route)
    ],
    exports: [
        RouterModule
    ]
})
export class AboutUsRoutingModule { }